









import { computed, defineComponent, toRef, watch } from "@vue/composition-api";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import useBeforeUnloadTab from "@/hooks/useBeforeUnloadTab";
import { $t } from "@/lib/i18nHelpers";
import BaseSpinner from "@/components/BaseSpinner";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "AliJapan",
  components: { BaseSpinner, ModalView },
  props: {
    show: { type: Boolean, required: true },
    processing: { type: Boolean, required: true },
    paymentSystem: { type: Object as () => PaymentSystemPublic, required: true },
    isSubscription: { type: Boolean, default: false },
    price: { type: String },
  },
  setup(props, { emit }) {
    useBeforeUnloadTab(
      $t("With closing browser tab funds could be billed from your credit card, but the purchase will not happened."),
      computed(() => !props.show)
    );

    watch(toRef(props, "show"), show => {
      if (show) {
        emit("submit");
        emit("setCloseOnError", true);
      }
    });
  },
});
